import Vue from 'vue';

let currentDomain = document.domain; // 私有部署自适应域名

if (currentDomain == 'localhost') {
  Vue.prototype.totalUrl = 'https://total.api.sz90.cn'; // 总后台api地址
  Vue.prototype.FrontUrl = 'https://account.sz90.cn'; // 前端域名
  Vue.prototype.ApiUrl = 'http://api.xl.cc/index.php'; // 后端api地址
  Vue.prototype.ImgUrl = 'http://api.xl.cc'; // 图片地址
  Vue.prototype.CloudUrl = 'http://api.xlcloud.cc/index.php';
  Vue.prototype.MqttUrl = "ws://127.0.0.1:8083/mqtt"
} else if (currentDomain == 'adm.sz90.cn') {
  Vue.prototype.totalUrl = 'https://total.api.sz90.cn'; // 总后台api地址
  Vue.prototype.FrontUrl = 'https://account.sz90.cn'; // 前端域名
  Vue.prototype.ApiUrl = 'https://adm.api.sz90.cn/index.php'; // 后端api地址
  Vue.prototype.ImgUrl = 'https://adm.api.sz90.cn'; // 图片地址
  Vue.prototype.CloudUrl = 'https://api.cloud.sz90.cn/index.php';
  Vue.prototype.MqttUrl = "wss://cs.cloud.sz90.cn/websocket/"
} else {
  /* 后端api地址 */
  Vue.prototype.ApiUrl = 'https://' + currentDomain + '/index.php';
  /* 总后台api地址*/
  Vue.prototype.totalUrl = 'https://total.api.sz90.cn';
  /* 图片地址 */
  Vue.prototype.ImgUrl = 'https://' + currentDomain;
  /* 前端域名 */
  Vue.prototype.FrontUrl = 'https://' + currentDomain;
  /* 云端域名 */
  Vue.prototype.CloudUrl = 'https://api.cloud.sz90.cn/index.php';
  Vue.prototype.MqttUrl = "wss://cs.cloud.sz90.cn/websocket/"
}


// WEBPACK FOOTER //
// ./src/assets/js/private.js